import { Col, Container, Nav, Row, Image } from "react-bootstrap";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";
import "./Footer.css";
import { NavLink } from "react-router-dom";

export default function Footer() {
    return (
        <Container className="footer-container">
            <Row>
                <Nav className="me-auto">
                    <Col xs={12} md={2} lg={2}>
                        <Nav.Link as={NavLink} to="/" end>
                            Anasayfa
                        </Nav.Link>
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                        <Nav.Link as={NavLink} to="/urunlerimiz">
                            Ürünlerimiz
                        </Nav.Link>
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                        <Nav.Link as={NavLink} to="/hakkimizda">
                            Hakkımızda
                        </Nav.Link>
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                        <Nav.Link as={NavLink} to="/franchise">
                            Franchise
                        </Nav.Link>
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                        <Nav.Link as={NavLink} to="/etkinliklerde-boac">
                            Etkinliklerde BOAC
                        </Nav.Link>
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                        <Nav.Link as={NavLink} to="/">
                            Blog
                        </Nav.Link>
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                        <Nav.Link as={NavLink} to="/iletisim">
                            İletişim
                        </Nav.Link>
                    </Col>
                </Nav>
            </Row>
            <Row style={{marginTop: '20px'}}>
                <Col>
                    <Image
                        width="120px"
                        src="https://boac-website.s3.eu-central-1.amazonaws.com/logo_white.png" />
                </Col>
            </Row>
            <Row style={{marginTop: '20px'}}>
                <Col>
                    <p style={{fontSize: '10px', margin: '0'}}>Designed by Dynamite Agency<br></br>2024</p>
                    <p>
                        <a style={{color: 'white'}} href="https://www.facebook.com/profile.php?id=61557954306563&locale=tr_TR" target="_blank" rel="noopener noreferrer">
                            <FaFacebookF style={{cursor: 'pointer'}}></FaFacebookF>
                        </a>
                        <a style={{color: 'white', margin: '0 30px'}} href="https://www.instagram.com/boacsoftserve" target="_blank" rel="noopener noreferrer">
                            <FaInstagram style={{cursor: 'pointer'}}></FaInstagram>
                        </a>
                        <a style={{color: 'white'}} href="https://www.tiktok.com/@boacsoftserve?is_from_webapp=1&sender_device=pc" target="_blank" rel="noopener noreferrer">
                            <FaTiktok style={{cursor: 'pointer'}}></FaTiktok>
                        </a>
                    </p>
                </Col>
            </Row>
        </Container>
    );
}
